import React from "react";
import PropTypes from "prop-types";
import logoWhite from "../../img/logo_total_white.svg";
import {FaSolidIcon} from "../../components/FontAwesomeIcons";

export function BookizonPlusLogo(props) {
    const badgeStyle = {
        backgroundColor: 'rgba(255,255,255,0.15)'
    };
    return (
        <React.Fragment>
            <div className={"d-flex align-items-center mb-2"}>
                <img src={logoWhite} height={40}/>
                <div
                    className={"badge badge-pill text-uppercase text-white d-inline-flex align-items-center px-3 py-2 ml-2 shadow-sm"} style={badgeStyle}>
                    Plus <FaSolidIcon name={"plus"} className={"ml-2"}/>
                </div>
            </div>
        </React.Fragment>
    )
}

BookizonPlusLogo.propTypes = {}
